import { DivolteEvent, InstallParameters } from './index';
import { QueuedAttempts } from '@/app/tools/QueuedAttempts';
import { iMetricsSender } from '@/app/modules/Metrics/types';
import { ClickStreamBootstrap } from '@/modules/Metrix/adapters/ClickStream';
import { getClientID } from '@/modules/Metrix/adapters/YandexMetrika';

export default class Loader implements iMetricsSender {
    /**
     * Делаем 20 попыток загрузки, каждые 200 мс
     */
    protected readonly AttemptsManager = new QueuedAttempts<DivolteEvent>(
        30,
        150,
        'CSC'
    );

    /**
     * Настраиваем кликстримы
     *
     * @param bootstrap_parameters
     */
    public bootstrap(bootstrap_parameters: InstallParameters): Promise<void> {
        return this.AttemptsManager.makeLoop(
            /* istanbul ignore next */
            () => window.divolte && typeof window.divolte.signal === 'function'
        ).then(() => {
            this.customizeDivolteSignal(bootstrap_parameters.merge_parameters);

            this.AttemptsManager.getQueue().forEach((packet) =>
                this.send(packet)
            );
        });
    }

    /**
     * Отправляем посылку
     *
     * @param send_parameters
     */
    public send(send_parameters: DivolteEvent) {
        if (this.AttemptsManager.getIsInstalled()) {
            const { type } = send_parameters;
            //@ts-ignore
            delete send_parameters.type; //TODO WTF

            window.divolte.signal(type, send_parameters);
        } else {
            this.AttemptsManager.addToQueue(send_parameters);
        }
    }

    /**
     * Устанавливаем свой колллбек, подмерживающий необходимые параметры к каждому запросу
     *
     * @param raw_merge_parameters
     */
    protected customizeDivolteSignal(
        raw_merge_parameters?: Partial<ClickStreamBootstrap>
    ) {
        const merge_parameters =
            typeof raw_merge_parameters === 'object'
                ? raw_merge_parameters
                : {};

        const signalOriginal = window.divolte.signal;

        window.divolte.signal = function customDivolteSignal(
            type: string,
            customParameters: any
        ) {
            if (
                typeof customParameters !== 'object' ||
                customParameters === null
            ) {
                customParameters = {};
            }

            // Перезаписываем дефолтные параметры
            const rewriteParameters =
                typeof customParameters.rewriteParameters === 'object'
                    ? customParameters.rewriteParameters
                    : {};

            delete customParameters.rewriteParameters;

            const finalParameters = Object.assign(
                {},
                merge_parameters,
                rewriteParameters,
                customParameters
            );

            // Divolte не принимает undefined значения
            const prepared = Object.keys(finalParameters).reduce((acc, key) => {
                if (typeof finalParameters[key] !== 'undefined') {
                    acc[key as keyof DivolteEvent] = finalParameters[key];
                }

                return acc;
            }, {} as DivolteEvent);

            log('Divolte', type, prepared);

            return signalOriginal.call(this, type, prepared);
        };
    }
}

function log(title: string, label: string | null, data: object) {
    if (process.env.VUE_APP_ENVIRONMENT !== 'production') {
        // немного dev-only извращений
        let maxLength = 0;

        const getColorByType = (label: string | null) => {
            if (!label) {
                return;
            }

            switch (label) {
                case 'buttonClick':
                    return '#c564a3';
                case 'pageView':
                    return '#50ab6c';
                case 'authEvent':
                    return '#28b2e8';
                default:
                    return '#bf0b4e';
            }
        };

        console.groupCollapsed(
            `%c ${title} %c ${label} %c`,
            `font-weight: bold; background: #752968; color: white; padding: 1px; border-radius: 3px 0 0 3px;`,
            `font-weight: bold; background: ${getColorByType(
                label
            )}; color: white; padding: 1px; border-radius: 0 3px 3px 0; font-weight: normal`,
            'background: transparent'
        );

        Object.entries(data)
            .sort((a, b) => a[0].localeCompare(b[0], 'en-EN-u-kn'))
            .map(([key, value]) => {
                if (key.length > maxLength) {
                    maxLength = ('' + key).length;
                }

                return [key, value];
            })
            .forEach(([key, value]) => {
                const spaces = new Array(maxLength - key.length)
                    .fill(Number)
                    .map(() => ' ')
                    .join('');

                console.log(
                    `${key} ${spaces} %c${
                        typeof value === 'object'
                            ? JSON.stringify(value)
                            : value
                    }`,
                    'color: blue'
                );
            });

        console.groupEnd();
    }
}
